import { adminAxios } from '../helpers/api';

export const getOperatingHours = () => adminAxios.get('operating-hours');

export const patchOperatingHourTime = ({ id, data }) =>
  adminAxios.patch(`operating-hours/${id}`, data);

export const patchOperatingHourStatus = ({ id, data }) =>
  adminAxios.patch(`operating-hours/${id}/set-daily-schedule-status`, data);
